import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import clsx from 'clsx';
import { InfoIcon } from 'lucide-react';
import React, { FC, ReactNode } from 'react';

import styles from '../styles.module.css';

const FormSectionTitle: FC<{
  classNames?: { container?: string; label?: string; tooltipIcon?: string };
  label: ReactNode;
  tooltip: ReactNode;
}> = ({ classNames, label, tooltip }) => {
  return (
    <Stack alignItems="center" className={classNames?.container} fullWidth gap={2} orientation="horizontal">
      <Text as="h2" className={clsx(styles.sectionTitle, classNames?.label)}>
        {label}
      </Text>
      <Tooltip content={tooltip} placement="right" trigger={<InfoIcon className={classNames?.tooltipIcon} />} />
    </Stack>
  );
};

export default FormSectionTitle;
